import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind sinflarini birlashtiradi va ZIDDIYATLARNI yechadi.
 *
 * `clsx` bir xil xususiyatli ikkita sinfni («px-2 px-4») ikkalasini ham
 * qoldiradi va natija CSS tartibiga bog'liq bo'lib qoladi. `twMerge`
 * oxirgisini tanlaydi — komponent props orqali uslubni ustidan yozish
 * shu tufayli ishonchli ishlaydi.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
